import { add, sub, format, startOfWeek, lastDayOfWeek, startOfMonth, lastDayOfMonth, startOfQuarter, lastDayOfQuarter, startOfYear, lastDayOfYear, subQuarters, parse, isBefore, isEqual, differenceInDays, parseISO, compareAsc } from 'date-fns'

const FORMAT_DATE = 'yyyy/MM/dd';
const FORMAT_DATE2 = 'yyyy-MM-dd';
const FORMAT_DATE3 = 'yyyyMMdd';

export const formatDate = (date) => {
  return format(date, FORMAT_DATE);
}

export const formatDate2 = (date) => {
  return format(date, FORMAT_DATE2);
}

export const formatDate3 = (date) => {
  return format(date, FORMAT_DATE3);
}

export const utcToDate = (date) => {
  const inputDate = parseISO(date);
  return format(inputDate, FORMAT_DATE);
}

// 當前日期時間的毫秒數
export const generateUniqueKey = () => {
  return `unique_key_${new Date().getTime()}`;
};

//今天 'yyyy/MM/dd'
const date = new Date();
const formateDate = (date) => {
  let formatted_date =
    date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + date.getDate();
  return formatted_date;
};
const nextFormateDate = (date) => {
  let formatted_date =
    date.getFullYear() + "/" + (date.getMonth() + 1) + "/" + (date.getDate() + 1);
  return formatted_date;
};

export const todaysDate = formateDate(date);
export const nextDate = nextFormateDate(date);

//今天
export const today = sub(new Date(), { days: 0 });

//昨天
export const yesterday = sub(new Date(), { days: 1 });

//前7天
export const last7day = sub(new Date(), { days: 7 });

//前30天
export const last30day = sub(new Date(), { days: 30 });

//上個月的第一天和最後一天
export const lastMonthFistDate = new Date(date.getFullYear(), date.getMonth() - 1, 1);
export const lastMonthlastDate = new Date(date.getFullYear(), date.getMonth(), 0);

export const parseDate = (date) => {
  return parse(date, FORMAT_DATE, new Date());
}

// date1不大於date2
export const compareAscDate = (date1, date2) => {
  return compareAsc(date1, date2);
}

// date1不大於等於date2
export const compareDate = (date1, date2) => {
  return isBefore(date1, date2);
}

export const timestampToDate = (date) => {
  return format(date * 1000, "yyyy-MM-dd");
}

export const dateRangeList = {
  today: {
    displayName: '今天',
    getRange: () => {
      const date = sub(new Date(), { days: 0 });
      return [date, date];
    },
    getPreviousRange: () => {
      const date = sub(new Date(), { days: 1 });
      return [date, date];
    }
  },
  yesterday: {
    displayName: '昨天',
    getRange: () => {
      const date = sub(new Date(), { days: 1 });
      return [date, date];
    },
    getPreviousRange: () => {
      const date = sub(new Date(), { days: 2 });
      return [date, date];
    }
  },
  last_7d: {
    displayName: '過去7天',
    getRange: () => {
      return [sub(new Date(), { days: 7 }), sub(new Date(), { days: 1 })];
    },
    getPreviousRange: () => {
      return [sub(new Date(), { days: 14 }), sub(new Date(), { days: 8 })];
    }
  },
  last_14d: {
    displayName: '過去14天',
    getRange: () => {
      return [sub(new Date(), { days: 14 }), sub(new Date(), { days: 1 })];
    },
    getPreviousRange: () => {
      return [sub(new Date(), { days: 28 }), sub(new Date(), { days: 15 })];
    }
  },
  last_30d: {
    displayName: '過去30天',
    getRange: () => {
      return [sub(new Date(), { days: 30 }), sub(new Date(), { days: 1 })];
    },
    getPreviousRange: () => {
      return [sub(new Date(), { days: 60 }), sub(new Date(), { days: 31 })];
    }
  },
  this_week: {
    displayName: '本週',
    getRange: (weekStart) => {
      const weekStartDate = startOfWeek(new Date(), { weekStartsOn: weekStart || 0 });
      const weekEndDate = lastDayOfWeek(new Date(), { weekStartsOn: weekStart || 0 });

      return [weekStartDate, weekEndDate];
    },
    getPreviousRange: (weekStart) => {
      const weekStartDate = startOfWeek(sub(new Date(), { weeks: 1 }), { weekStartsOn: weekStart || 0 });
      const weekEndDate = lastDayOfWeek(sub(new Date(), { weeks: 1 }), { weekStartsOn: weekStart || 0 });

      return [weekStartDate, weekEndDate]
    }
  },
  last_week: {
    displayName: '上週',
    getRange: (weekStart) => {
      const weekStartDate = startOfWeek(sub(new Date(), { weeks: 1 }), { weekStartsOn: weekStart || 0 });
      const weekEndDate = lastDayOfWeek(sub(new Date(), { weeks: 1 }), { weekStartsOn: weekStart || 0 });

      return [weekStartDate, weekEndDate]
    },
    getPreviousRange: (weekStart) => {
      const weekStartDate = startOfWeek(sub(new Date(), { weeks: 2 }), { weekStartsOn: weekStart || 0 });
      const weekEndDate = lastDayOfWeek(sub(new Date(), { weeks: 2 }), { weekStartsOn: weekStart || 0 });

      return [weekStartDate, weekEndDate]
    }
  },
  this_month: {
    displayName: '本月',
    getRange: () => {
      const monthStartDate = startOfMonth(new Date());
      const monthEndDate = lastDayOfMonth(new Date());

      return [monthStartDate, monthEndDate];
    },
    getPreviousRange: () => {
      const monthStartDate = startOfMonth(sub(new Date(), { months: 1 }));
      const monthEndDate = lastDayOfMonth(sub(new Date(), { months: 1 }));

      return [monthStartDate, monthEndDate]
    }
  },
  last_month: {
    displayName: '上個月',
    getRange: () => {
      const monthStartDate = startOfMonth(sub(new Date(), { months: 1 }));
      const monthEndDate = lastDayOfMonth(sub(new Date(), { months: 1 }));

      return [monthStartDate, monthEndDate]
    },
    getPreviousRange: () => {
      const monthStartDate = startOfMonth(sub(new Date(), { months: 2 }));
      const monthEndDate = lastDayOfMonth(sub(new Date(), { months: 2 }));

      return [monthStartDate, monthEndDate]
    }
  },
  this_quarter: {
    displayName: '本季',
    getRange: () => {
      const quarterStartDate = startOfQuarter(new Date());
      const quarterEndDate = lastDayOfQuarter(new Date());

      return [quarterStartDate, quarterEndDate]
    },
    getPreviousRange: () => {
      const lastQuarter = subQuarters(new Date(), 1);
      const quarterStartDate = startOfQuarter(lastQuarter);
      const quarterEndDate = lastDayOfQuarter(lastQuarter);

      return [quarterStartDate, quarterEndDate]
    }
  },
  last_quarter: {
    displayName: '上一季',
    getRange: () => {
      const lastQuarter = subQuarters(new Date(), 1);
      const quarterStartDate = startOfQuarter(lastQuarter);
      const quarterEndDate = lastDayOfQuarter(lastQuarter);

      return [quarterStartDate, quarterEndDate]
    },
    getPreviousRange: () => {
      const lastQuarter = subQuarters(new Date(), 2);
      const quarterStartDate = startOfQuarter(lastQuarter);
      const quarterEndDate = lastDayOfQuarter(lastQuarter);

      return [quarterStartDate, quarterEndDate]
    }
  },
  this_year: {
    displayName: '今年',
    getRange: () => {
      const yearStartDate = startOfYear(new Date());
      const yearEndDate = lastDayOfYear(new Date());

      return [yearStartDate, yearEndDate];
    },
    getPreviousRange: () => {
      const yearStartDate = startOfYear(sub(new Date(), { years: 1 }));
      const yearEndDate = lastDayOfYear(sub(new Date(), { years: 1 }));

      return [yearStartDate, yearEndDate]
    }
  },
  last_year: {
    displayName: '去年',
    getRange: () => {
      const yearStartDate = startOfYear(sub(new Date(), { years: 1 }));
      const yearEndDate = lastDayOfYear(sub(new Date(), { years: 1 }));

      return [yearStartDate, yearEndDate]
    },
    getPreviousRange: () => {
      const yearStartDate = startOfYear(sub(new Date(), { years: 2 }));
      const yearEndDate = lastDayOfYear(sub(new Date(), { years: 2 }));

      return [yearStartDate, yearEndDate]
    }
  },
  custom: {
    displayName: '自訂',
    getRange: () => {
      return [new Date(), new Date()];
    },
    getPreviousRange: () => {
      const date = sub(new Date(), { days: 1 });
      return [date, date];
    }
  }
}

export const getPastPeriod = (diff) => {
  const today = new Date();
  const startDate = sub(new Date(), { days: diff });
  const endDate = sub(new Date(), { days: 1 });
  // const year = today.getFullYear();
  // const month = today.getMonth();
  // const date = today.getDate();

  return {
    startDate: format(startDate, FORMAT_DATE),
    endDate: format(endDate, FORMAT_DATE)
  }
}

export const getFutureDate = (startDate, diff) => {
  const date = add(startDate, { days: diff })

  return format(date, FORMAT_DATE)
}

//顯示一天的日期或日期區間
export const handleDateRange = (startDate, endDate) => {
  let dateRange;
  if (compareAscDate(startDate, endDate) === 0) {
    dateRange = formatDate3(startDate);
  } else {
    dateRange = formatDate3(startDate) + '-' + formatDate3(endDate)
  }
  return dateRange;
}